import React, { useEffect, useState } from "react";
import { Sparkles, Plus } from "lucide-react";
import { loadSynergies } from "../lib/synergies";
import { loadProducts } from "./ResearchStacks";

// Cart cross-sell: top 2 complementary compounds for what's already in the cart.
export default function CartSynergyHint({ items, addItem, wholesale }) {
  const [map, setMap] = useState({});
  const [all, setAll] = useState([]);
  useEffect(() => { loadSynergies().then(setMap); loadProducts().then(setAll); }, []);
  if (wholesale || !items.length) return null;

  const inCart = new Set(items.map((i) => i.slug));
  const bySlug = Object.fromEntries(all.map((p) => [p.slug, p]));
  const score = {};
  items.forEach((i) => (map[i.slug] || []).forEach((r, idx) => {
    if (inCart.has(r.slug)) return;
    score[r.slug] = score[r.slug] || { reason: r.reason, from: i.name, pts: 0 };
    score[r.slug].pts += 10 - idx;
  }));
  const recs = Object.entries(score)
    .sort((a, b) => b[1].pts - a[1].pts)
    .map(([slug, v]) => ({ ...v, product: bySlug[slug] }))
    .filter((r) => r.product?.variants?.length)
    .slice(0, 2);
  if (!recs.length) return null;

  return (
    <div data-testid="cart-synergy-hints" className="space-y-2">
      <div className="overline flex items-center gap-2"><Sparkles size={11} /> COMPLEMENTS YOUR CART</div>
      {recs.map(({ product, reason, from }) => (
        <div key={product.slug} data-testid={`cart-synergy-${product.slug}`} className="flex items-center gap-3 p-3 border border-white/10 bg-white/[0.02]">
          <div className="flex-1 min-w-0 text-xs leading-relaxed">
            <div className="text-white truncate">{product.name}</div>
            <div className="text-[#5C657A] text-[11px] truncate">{reason} · pairs with {from}</div>
          </div>
          <button
            data-testid={`cart-synergy-add-${product.slug}`}
            onClick={() => addItem(product, product.variants[0], 1)}
            className="inline-flex items-center gap-1 px-3 py-1.5 border border-[#00C3FF]/50 text-[#00C3FF] hover:bg-[#00C3FF]/10 font-mono-tech text-[10px] uppercase tracking-[0.15em] transition-colors shrink-0"
          >
            <Plus size={12} /> ${Number(product.variants[0].price).toFixed(2)}
          </button>
        </div>
      ))}
    </div>
  );
}
